import { TRPCClientError } from "@trpc/client";

export const isRetryableTRPCError = (error: unknown): boolean => {
  if (error instanceof TRPCClientError) {
    const statusCode = error.data?.httpStatus;

    if (statusCode === 500) return true;
    if (!statusCode) return true;
  }
  return false;
};
